import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-739a27ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "curtain" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogBox',
  props: {
    Width: {},
    Height: {},
    BackGroundColor: {},
    loading: { type: Boolean },
    loadingMessage: {},
    loadingFontSize: {},
    loadingIconSize: {},
    loadingColor: {}
  },
  setup(__props: any) {

const props = __props;

/* eslint-disable */


return (_ctx: any,_cache: any) => {
  const _component_LoadingMask = _resolveComponent("LoadingMask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "Dialog-box",
      style: _normalizeStyle({ width: _ctx.Width ? _ctx.Width + 'px' : '', height: _ctx.Height ? _ctx.Height + 'px' : '', backgroundColor: _ctx.BackGroundColor ?? '' })
    }, [
      _withDirectives(_createVNode(_component_LoadingMask, {
        text: _ctx.loadingMessage ?? '正在加载中，请稍后......',
        fontSize: _ctx.loadingFontSize ?? '24',
        iconSize: _ctx.loadingIconSize ?? '20',
        color: _ctx.loadingColor ?? '#FC8F28'
      }, null, 8, ["text", "fontSize", "iconSize", "color"]), [
        [_vShow, _ctx.loading]
      ]),
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickClose')))
      })
    ], 4)
  ]))
}
}

})